import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-workbook-outline",
  "use": "sd-workbook-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-workbook-outline\"><path opacity=\".5\" d=\"M17 3v9l-2.5-2-2.5 2V3h5z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 4a3 3 0 013-3h12a3 3 0 013 3v16a3 3 0 01-3 3H6a3 3 0 01-3-3V4zm15-1a1 1 0 011 1v16a1 1 0 01-1 1H8V3h10zM7 3H6a1 1 0 00-1 1v16a1 1 0 001 1h1V3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol